import { DataGrid, type GridColDef } from '@mui/x-data-grid';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { Outlet } from 'react-router';
import { useEffect, useState } from 'react';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import { supabase } from '../supabase-client';
import type { Voucher } from '../models/types';
import moment from 'moment';
import { getVoucher } from '../fetchFns';

export default function Vouchers() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const [vouchers, setVouchers] = useState<Voucher[]>([
    // {
    //   id: 1,
    //   merchant_id: 1,
    //   campaign_id: 1,
    //   merchant_name: 'Starbucks',
    //   campaign_name: 'Christmas drinks promo',
    //   description: 'Get 50% off on all Christmas drinks.',
    //   voucher_code: 'XMAS2026',
    //   expiry_date: '2026-12-25',
    //   minimum_spend: 10,
    //   referee_benefit_type: 'amount',
    //   referee_benefit_description: 'Get $2 off on all Christmas drinks.',
    //   referee_benefit_amount: 2,
    // },
  ]);
  const columns: GridColDef<Voucher>[] = [
    // {
    //   field: 'id',
    //   headerName: 'Action',
    //   width: 100,
    //   renderCell: (param) => (
    //     <Button
    //       variant="outlined"
    //       onClick={() => {
    //         dialog.handleDialogOpen(
    //           <DeleteCampaignDialog
    //             merchantId={param.value}
    //             campaignId={param.row.id}
    //           />,
    //           `Delete Voucher - ${param.row.voucher_code}`,
    //         );
    //       }}>
    //       <DeleteIcon />
    //     </Button>
    //   ),
    // },
    {
      field: 'voucher_code',
      headerName: 'Code',
      width: 160,
    },
    {
      field: 'email',
      headerName: 'User Email',
      width: 200,
    },
    {
      field: 'merchant_name',
      headerName: 'Brand',
      width: 100,
    },
    {
      field: 'campaign_name',
      headerName: 'Campaign Name',
      width: 180,
    },
    {
      field: 'referee_benefit_type',
      headerName: 'Referee Benefit Type',
      width: 100,
      type: 'string',
    },
    {
      field: 'referee_benefit_amount',
      headerName: 'Referee Benefit Amount',
      width: 150,
      type: 'number',
    },
    {
      field: 'referee_benefit_description',
      headerName: 'Referee Benefit Description',
      width: 200,
    },
    {
      field: 'expiry_date',
      headerName: 'Expiry Date',
      width: 100,
      type: 'string',
    },
    {
      field: 'redeemed',
      headerName: 'Redeemed',
      width: 100,
      type: 'boolean',
    },
    {
      field: 'redeemed_at',
      headerName: 'Redeemed At',
      width: 100,
      type: 'date',
      valueGetter: (params) => params && new Date(params),
      valueFormatter: (params) => {
        if (!params) return '';
        return moment(params).format('DD MMM YYYY');
      },
    },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await getVoucher();

      if (error) {
        console.error('Error fetching vouchers:', error);
        throw error;
      }

      setVouchers(data.data);
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout
      title="Vouchers"
      //   actions={
      //     <Button
      //       component={Link}
      //       to="./new"
      //       startIcon={<GridAddIcon />}
      //       size="small"
      //       variant="contained">
      //       New Campaign
      //     </Button>
      //   }
    >
      {/* <Button
        onClick={async () => {
          const response = await supabase.functions.invoke(
            'vouchers/WEILONGVOUCHER2/redeem',
            { method: 'POST' },
          );
          console.log(response.data);
        }}
        startIcon={<GridAddIcon />}
        size="small"
        variant="contained">
        xdts
      </Button> */}
      <DataGrid columns={columns} rows={vouchers} />
      <Outlet />
    </PageBaseLayout>
  );
}
